import { Button, notification } from "antd";
import { getMainSearchResult, searchByName, startSearching, updateSearch } from "api/search.api";
import { notificationController } from "components/Common/Notification/Notification";

import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useParams, useSearchParams } from "react-router-dom";
import {
  doCancelSearch,
  setActiveStep,
  setProcessingSearchId,
  setSearchLoading,
  setSearchStatus,
} from "store/slices/searcSlice";
import { RootState } from "store/store";
const win: any = window;
win.graph_search_id = null;
interface Prop {
  onCounterChange?: any;
  onSearchStatusChange?: any;
  onGraphIdReceived?: any;
  isModal?: any;
  onSearch?: any;
  isFilterQuery?: boolean;
  isSmall?: boolean;
  setIsSearchLoading?: any;
  runFrom?: string;
  handleNavigation?: any;
}
const SearchCandidateButton: React.FC<Prop> = ({
  onCounterChange,
  onSearchStatusChange,
  onGraphIdReceived,
  setIsSearchLoading,
  runFrom,
  handleNavigation,
}) => {
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const Full = useSelector((state: RootState) => state.search.search_name);
  const jobTitle = useSelector((state: RootState) => state.search.job_titles);
  const searchingLoading = useSelector((state: RootState) => state.search.searchingLoading);
  const [count, setCount] = useState(0);
  const [graphId, setGraphId] = useState<any>(null);
  const processSearchId = useAppSelector((state) => state.search.processing_search_id);
  const project = useAppSelector((state) => state.search.selectedProject);
  const roleId = useAppSelector((state) => state.search.selectedProject?.id);
  const jobTitlesData = useAppSelector((state) => state.search.job_titles);
  const locationsData = useAppSelector((state) => state.search.locations);
  const locationRadius = useAppSelector((state) => state.search.location_radius);
  const search_name: any = useAppSelector((state) => state.search.search_name);
  const minExp = useAppSelector((state) => state.search.min_exp);
  const maxExp = useAppSelector((state) => state.search.max_exp);
  const skillsData = useAppSelector((state) => state.search.skills);
  const universitiesData = useAppSelector((state) => state.search.universities);
  const industryData = useAppSelector((state) => state.search.industries);
  const agencies = useAppSelector((state) => state.search.agencies);
  const agencyParent = useAppSelector((state) => state.search.agency_parents);
  const agencyType = useAppSelector((state) => state.search.agency_types);
  const industryType = useAppSelector((state) => state.search.industry_type);
  const industryLeaders = useAppSelector((state) => state.search.industry_leaders);
  const industrySegment = useAppSelector((state) => state.search.segments);
  const schoolGroups = useAppSelector((state) => state.search.school_groups);
  const keywords = useAppSelector((state) => state.search.keywords);
  const tied_to_role = useAppSelector((state) => state.search.tied_to_role);
  const exact_job_title_match = useAppSelector((state) => state.search.exact_job_title_match);
  const must_have_keywords = useAppSelector((state) => state.search.must_have_keywords);
  const search_only_greenhouse_mckinney = useAppSelector(
    (state) => state.search.search_only_greenhouse_mckinney
  );
  const search_question_set_id = useAppSelector(
    (state) => state.search.search_question_set_id || null
  );
  const search_only_lever_ss = useAppSelector((state) => state.search.search_only_lever_ss);
  const searchFullName = useSelector((state: any) => state.search.full_name);
  const education_fields = useAppSelector((state) => state.search.education_fields);
  const education_levels = useAppSelector((state) => state.search.education_levels);
  const full_name = useAppSelector((state) => state.search.full_name);
  const [searchParams, setSearchParams] = useSearchParams();
  const params = useParams();
  const searchId: any = searchParams.get("searchId") ? searchParams.get("searchId") : 0;
  const graphSearchId: any = params.graphSearchId;
  const worked_previously_at_companies = useAppSelector(
    (state) => state.search.worked_previously_at_companies
  );
  const allow_previous_job_titles = useAppSelector(
    (state) => state.search.allow_previous_job_titles
  );

  const { is_extension_search, is_freelance_search } = useAppSelector((state) => state.search);
  const include_subsidiaries = useAppSelector((state) => state.search.include_subsidiaries);
  const exclude_subsidiaries = useAppSelector((state) => state.search.exclude_subsidiaries);
  const exclude_years = useAppSelector((state) => state.search.exclude_years);
  const excludedLocations = useAppSelector((state) => state.search.exclude_locations);

  const candidateWorkData = useAppSelector((state) => state.search.company);
  const excludeData = useAppSelector((state) => state.search.exclude_company);
  const isCancelling = useAppSelector((state: RootState) => state.search.isCancelling);
  const everWorked = useAppSelector((state) => state.search.ever_worked);
  const isHealthcare = useAppSelector((state) => state.search.run_doximity);
  const run_sinecure_search = useAppSelector((state) => state.search.run_sinecure_search);

  const setSearchingLoading = (val: boolean) => {
    dispatch(setSearchLoading(val));
  };

  const maxCount = is_extension_search ? 500 : 300;

  const stopSearching = () => {
    const win: any = window;
    if (win["axiosAbort"]) win["axiosAbort"].abort();

    setSearchingLoading(false);
    onSearchStatusChange && onSearchStatusChange("end");
    dispatch(setSearchStatus("end"));
    setCount(0);
    return;
  };

  const handleStopSearch = () => {
    if (processSearchId) {
      dispatch(doCancelSearch(processSearchId));
    }
  };

  useEffect(() => {
    if (!processSearchId) {
      stopSearching();
      return;
    }
    const controller = new AbortController();
    const win: any = window;
    delete win["axiosAbort"];
    win["axiosAbort"] = controller;
    getMainSearchResult(processSearchId)
      .then((data: any) => {
        if (data.count) {
          handleNavigation(processSearchId, win.graph_search_id, roleId);
          dispatch(setActiveStep(0));
          dispatch(setProcessingSearchId(null));
        } else {
          if (is_extension_search) {
            handleNavigation(processSearchId, win.graph_search_id, roleId);
            // dispatch(setActiveStep(0));
            dispatch(setProcessingSearchId(null));
          }
          if (count < maxCount && processSearchId) {
            onSearchStatusChange && onSearchStatusChange("pending");
            dispatch(setSearchStatus("pending"));
            setCount((count) => {
              onCounterChange && onCounterChange(count + 1);
              return count + 1;
            });
          } else {
            api.error({
              message:
                "Oops! It looks like you need to adjust your search criteria to deliver better matches.",
            });
            dispatch(setProcessingSearchId(null));
            if (processSearchId) console.log("Search Result issue");
          }
        }
      })
      .catch((e) => {
        onCounterChange && onCounterChange(maxCount);
        api.error({
          message: "Something went wrong while searching candidate",
        });
        dispatch(setProcessingSearchId(null));
        if (processSearchId) console.log("Search Result issue");
      });
  }, [count, processSearchId]);

  const getSearchParam = () => {
    const finalData: any = {
      search_title: search_name
        ? search_name
        : jobTitlesData && jobTitlesData.length
          ? jobTitlesData[0]
          : "No Title",
      skills: skillsData,
      job_title: jobTitlesData,
      run_from: runFrom ?? "Filters",
      min_experience: minExp,
      max_experience: maxExp,
      company: candidateWorkData,
      companies_excluded: excludeData,
      allow_previous_companies: worked_previously_at_companies,
      allow_previous_job_titles: allow_previous_job_titles,
      is_extension_search: is_extension_search,
      is_freelance_search: is_freelance_search,

      include_subsidiaries: include_subsidiaries,
      exclude_subsidiaries: exclude_subsidiaries,
      exclude_years: exclude_years,
      // company_groups: industryType,
      ever_worked: everWorked,
      run_doximity: isHealthcare,
      selected_question_set: search_question_set_id ? search_question_set_id : null,
      company_groups: industrySegment,
      school_groups: schoolGroups,
      locations: locationsData,
      location_radius: locationRadius,
      locations_excluded: excludedLocations,
      allow_previous_locations: false,
      // industries: industryData,
      run_sinecure_search: run_sinecure_search,
      industries: industryType,
      search_id: graphSearchId ? graphSearchId : 0,
      update_search: graphSearchId ? true : false,
      keywords: keywords,

      education_levels: education_levels,
      education_fields: education_fields,
      tied_to_role: tied_to_role,
      exact_job_title_match: exact_job_title_match,
      search_only_greenhouse_mckinney: search_only_greenhouse_mckinney,
      search_only_lever_ss: search_only_lever_ss,
      agency_tree: {
        selected_agencies: agencies,
        selected_groups: agencyParent,
        selected_types: agencyType,
      },
      search_wizard_config: {
        worked_previously_at_companies: worked_previously_at_companies,
        allow_previous_job_titles: allow_previous_job_titles,
        include_subsidiaries: include_subsidiaries,
        exclude_subsidiaries: exclude_subsidiaries,
        exclude_years: exclude_years,
        ever_worked: everWorked,
        run_doximity: isHealthcare,
        selected_question_set: search_question_set_id ? search_question_set_id : null,
        is_extension_search: is_extension_search,
        is_freelance_search: is_freelance_search,
        // companyGroups: industryType,
        companyGroups: industrySegment,
        school_groups: schoolGroups,
        locations: locationsData,
        company: candidateWorkData,
        companies_exclude: excludeData,
        agencies: agencies,
        agencyParent: agencyParent,
        agencyType: agencyType,
        locations_exclude: excludedLocations,
        location_radius: locationRadius,
        keywords: keywords,

        job_title: jobTitlesData,
        // industries: industryData,
        industries: industryType,
        universities: universitiesData,
        skills: skillsData,
        minExp: minExp,
        maxExp: maxExp,
        education_levels: education_levels,
        education_fields: education_fields,
        tied_to_role: tied_to_role,
        exact_job_title_match: exact_job_title_match,
      },
      job: roleId,

      must_have_skill: skillsData,
      must_have_keywords: must_have_keywords ? keywords : [],

      parent_search: "",
      universities: universitiesData,
    };
    if (fullName) finalData["full_name"] = fullName;
    return finalData;
  };
  const initiateSearch = () => {
    const searchParam = getSearchParam();
    setSearchingLoading(true);

    setSearchingLoading(true);

    if (searchId) {
      updateSearch(searchId, getSearchParam()).then(
        (search: any) => {
          dispatch(setProcessingSearchId(search.id));
          onGraphIdReceived && onGraphIdReceived(search.graph_search_id);
          win.graph_search_id = search.graph_search_id;
          setGraphId(search.graph_search_id);
        },
        (err: any) => {
          api.error({ message: err.message.toString() });
        }
      );
    } else {
      startSearching(getSearchParam()).then(
        (search: any) => {
          dispatch(setProcessingSearchId(search.id));
          onGraphIdReceived && onGraphIdReceived(search.graph_search_id);
          win.graph_search_id = search.graph_search_id;
          setGraphId(search.graph_search_id);
        },
        (err: any) => {
          api.error({ message: err.message.toString() });
        }
      );
    }
  };
  useEffect(() => {
    setIsSearchLoading && setIsSearchLoading(searchingLoading);
  }, [searchingLoading]);

  const isNamedSearch = useSelector((state: any) => state.search.isNamedSearch);
  const fullName = useSelector((state: any) => state.search.full_name);

  return (
    <>
      {contextHolder}
      <Button
        onClick={() => initiateSearch()}
        loading={searchingLoading}
        size={"large"}
        // icon={<FilterOutlined></FilterOutlined>}
        className="big-search-btn bg-primary text-white"
      >
        {!is_extension_search ? (searchId ? "Update Search" : "Run Your Search") : "Next"}
      </Button>
      {searchingLoading && (
        <Button
          size={"large"}
          onClick={handleStopSearch}
          type="default"
          disabled={isCancelling || !processSearchId}
        >
          {isCancelling ? "Cancelling..." : "Cancel"}
        </Button>
      )}
    </>
  );
};
export default SearchCandidateButton;
